import { parseElementsToString } from '../../modules/quality/ocr/ScannedDocuments/Create/Delivery/formItems';
import { checkRules, ruleTransformer } from '../../utils/formRules';

function findError(array, error) {
  return array.findIndex((element) => element[0].id === error[0].id);
}

export function formReducer(state, action) {
  const objectForm = state[action.field];
  switch (action.type) {
    case 'updateFormField':
      if (objectForm.customValidation) {
        const executionResult = objectForm.customValidation(
          state,
          action.value,
        );
        return { ...state, ...executionResult };
      } else {
        objectForm.value = action.value;
        objectForm.status = checkRules(action.value, objectForm.rules);
        return { ...state, [action.field]: objectForm };
      }
    case 'updateFormStatus':
      objectForm.loading = action.status;
      return { ...state, [action.field]: objectForm };
    case 'addErrorStatus':
      if (findError(objectForm.status, action.error) === -1)
        objectForm.status.push(action.error);
      return { ...state, [action.field]: objectForm };
    case 'removeErrorStatus':
      const errorIndex = findError(objectForm.status, action.error);
      if (errorIndex > -1) objectForm.status.splice(errorIndex, 1);

      return { ...state, [action.field]: objectForm };

    default:
      return { ...state, templateErrorMessages: 'formReducer error' };
  }
}

export function validableReducer(state, action) {
  switch (action.type) {
    case true:
      return { ...state, [action.key]: true };
    case false:
      return { ...state, [action.key]: false };
    default:
      return {};
  }
}

export function selectedReducer(state, action) {
  switch (action.type) {
    case 'setSelected':
      return { ...state, [action.key]: true };
    case 'setNotSelected':
      return { ...state, [action.key]: false };
    default:
      return { ...state, templateErrorMessages: 'selectedReducer' };
  }
}

export const formToValidObject = (form) => {
  var newObj = {};
  Object.keys(form).forEach((key) => {
    if (key === 'elements') {
      newObj[key] = parseElementsToString(form[key].value, ',');
    } else if (key !== 'compressive_strength')
      newObj[key] = ruleTransformer(form[key]);
    else Object.assign(newObj, ruleTransformer(form[key]));
  });

  return newObj;
};
